"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _shapes = _interopRequireDefault(require("./shapes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Renders NotificationEmpty data.
 *
 * @class NotificationEmpty
 * @public
 *
 * @returns {React.ReactElement} NotificationsEmpty component
 */

class NotificationsEmpty extends _react.Component {
  render() {
    const {
      error
    } = this.props;
    if (error) {
      const {
        sso,
        messages: {
          failedNotificationsTitle,
          failedNotificationsText,
          failedNotificationsLink,
          notificationsError
        }
      } = this.props;
      const classes = 'notifications-list-empty notifications-session-alert';
      let errorContent = /*#__PURE__*/_react.default.createElement("div", null, notificationsError);
      if (error && error.status === 401) {
        errorContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, failedNotificationsTitle, /*#__PURE__*/_react.default.createElement("div", null, failedNotificationsText), /*#__PURE__*/_react.default.createElement("a", sso.login, failedNotificationsLink));
      }
      return /*#__PURE__*/_react.default.createElement("li", {
        className: classes
      }, errorContent);
    }
    const {
      messages: {
        noNotificationsTitle,
        noNotificationsText
      }
    } = this.props;
    const classes = 'notifications-list-empty notifications-alert';
    return /*#__PURE__*/_react.default.createElement("li", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement("strong", null, noNotificationsTitle), /*#__PURE__*/_react.default.createElement("div", {
      className: "no-notifications-text"
    }, noNotificationsText));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 *
 */

NotificationsEmpty.propTypes = {
  /** Used for sign on link when there is 401 error */
  sso: _shapes.default.sso.isRequired,
  /** Notification strings with translations */
  messages: _shapes.default.messages.isRequired,
  /** Provides error code */
  error: _propTypes.default.object
};
var _default = NotificationsEmpty;
exports.default = _default;